import { useSelector } from 'react-redux'

import { AuthenticatedUser } from '../redux/types'
import { RootState } from 'redux/reducers'

export default function useCurentUser(): AuthenticatedUser | undefined {
  const user = useSelector((state: RootState) => state.auth.user)
  return user
}
